import { render, staticRenderFns } from "./button-back.vue?vue&type=template&id=775cbb4c"
import script from "./button-back.vue?vue&type=script&lang=js"
export * from "./button-back.vue?vue&type=script&lang=js"
import style0 from "./button-back.vue?vue&type=style&index=0&id=775cbb4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports